import React, {Component} from "react";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";

// core components
import ListingTableHead from "components/Product/Table/ListingTableHead";

// actions
import {setIsSelectAll, setSelected} from "../../../actions/product/selection";
import {hasProductEditionAuthorization} from "utils/authorizations";

import {UserAgentUtils} from "../../../utils/useragent";

class ProductsTableHead extends Component {
    getTableHeadRows = () => {
        return [
            {id: "ranking", numeric: false, disablePadding: true, label: this.props.intl.formatMessage({id: "retailer.product.list.header.ranking"}), tooltipId: "retailer.product.list.header.ranking.tooltip"},
            {id: "article", numeric: false, disablePadding: true, label: this.props.intl.formatMessage({id: "retailer.product.list.header.article"})},
            {id: "lowestPrice", numeric: true, disablePadding: true, label: this.props.intl.formatMessage({id: "retailer.product.list.header.price"}), hideOnMobile: true},
            {id: "sales", numeric: true, disablePadding: true, label: this.props.intl.formatMessage({id: "retailer.product.list.header.sales"}), hideOnMobile: true},
            {id: "scoring", numeric: true, disablePadding: true, label: this.props.intl.formatMessage({id: "retailer.product.list.header.scoring"}), tooltipId: "retailer.product.list.header.scoring.tooltip", hideOnMobile: true},
            // "Stock" on both offers: the column shows stock and status alike, but the
            // DS labels it Stock. The longer "Stock et statut" wording stays on the
            // variation list, which has its own header.
            {id: "stock", numeric: true, disablePadding: true, label: this.props.intl.formatMessage({id: "retailer.product.list.header.stock"}), hideOnMobile: true},
        ];
    }

    render() {
        const {onSelectAllClick, isSelectAll, authorizations} = this.props;

        const canShowCheckbox = hasProductEditionAuthorization(authorizations);

        return (
            <ListingTableHead
                rows={this.getTableHeadRows()}
                mergeCheckboxInFirstCell={true}
                showCheckbox={!UserAgentUtils.isMobile() && canShowCheckbox}
                onSelectAllClick={onSelectAllClick}
                isSelectAllChecked={isSelectAll}
                checkboxDisabled={!this.props.isRetrievedFinished}
            />
        );
    }
}

ProductsTableHead.propTypes = {
    onSelectAllClick: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
    return {
        selected: state.product.selection.selected,
        isSelectAll: state.product.selection.isSelectAll,
        authorizations: state.authentication.authorizations,
    };
};

const mapDispatchToProps = dispatch => ({
    setSelected: (selected) => dispatch(setSelected(selected)),
    setIsTotalSelected: (selected) => dispatch(setIsSelectAll(selected)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(ProductsTableHead));
